import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup } from '@angular/forms';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'repeat-label-section-type',
  standalone: true,
  imports: [CommonModule, FormlyModule, MatDividerModule],
  styleUrls: ['../../config-page/config-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
   <div>
      <div *ngFor="let f of field.fieldGroup; let i = index;" class="mb-2">
        <div class="flex flex-row items-end gap-4">

          <formly-field
            *ngFor="let innerField of f.fieldGroup"
            [field]="innerField"
            class="flex-1"
            [class.is-invalid]="isFieldInvalid(innerField)">
          </formly-field>
          <button type="button" (click)="remove(i)"
                    class="flex-shrink-0 flex items-center justify-center mb-3
                        bg-transparent border-none
                        w-8 h-8 transition"
                    aria-label="Rimuovi segnale">
                <span class="material-icons text-red-700 hover:text-red-900">delete</span>
            </button>

        </div>
      </div>
       <div class="w-full flex justify-left">
        <button
            type="button"
            class="mt-2 flex items-center gap-2 bg-transparent border-none text-black hover:text-gray-600 w-auto transition px-3 py-1"
            (click)="add()"
            aria-label="Aggiungi segnale"
            >
            <span class="text-xl leading-none">+</span>
            <span>{{ props.addText || 'Aggiungi segnale digitale' }}</span>
        </button>
      </div>
      <div *ngIf="validationErrorMessage" class="text-red-500 text-sm">
        {{ validationErrorMessage }}
      </div>
    </div>
    <mat-divider class="mb-3 mt-3"></mat-divider>
  `
})
export class RepeatLabelSectionTypeComponent extends FieldArrayType implements OnInit {
  validationErrorMessage: string | null = null;

  ngOnInit() {
    this.checkAllRowsValid();
  }

  add() {
    if (this.checkAllRowsValid()) {
      super.add();
    }
  }

  remove(i: number) {
    super.remove(i);
    this.checkAllRowsValid(); // Controlla la validità dopo la rimozione
  }

  checkAllRowsValid(): boolean {
    if (!this.field.fieldGroup || this.field.fieldGroup.length === 0) {
      this.validationErrorMessage = null;
      return true; // Se non ci sono righe, abilita
    }

    const isValid = this.field.fieldGroup.every(row => {
      // Controlla se la riga ha un fieldGroup e se entrambi i campi sono validi
      if (!row.fieldGroup) return false; // Se non ha un fieldGroup, considera non valido
      return row.fieldGroup.every(innerField => innerField.formControl?.valid);
    });

    if (!isValid) {
      this.validationErrorMessage = 'Compila tutti i campi obbligatori prima di aggiungere una nuova riga.';
    } else {
      this.validationErrorMessage = null;
    }

    return isValid;
  }

  isFieldInvalid(field: FormlyFieldConfig): boolean {
    return !!(field.formControl?.invalid && field.formControl?.touched);
  }
}
